import { render, staticRenderFns } from "./Requested.vue?vue&type=template&id=b5f3f1ec&"
import script from "./Requested.vue?vue&type=script&lang=js&"
export * from "./Requested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports